import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"


export async function getInferenceCameras() {
  const inferenceCameraApi = "/v1/inferenceCameras";
  let inferenceCameras = []

  await axios
    .get(inferenceCameraApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("inferenceCameraNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then(response => {
      if (response.data.inference_cameras != undefined) {
        inferenceCameras = response.data.inference_cameras
      }
    })

  return inferenceCameras
}

export async function addInferenceCamera(data) {
  const inferenceCameraApi = "/v1/inferenceCameras";

  await axios
    .post(inferenceCameraApi, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("inferenceCameraNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
}

export async function updateInferenceCamera(data) {
  const inferenceCameraApi = "/v1/inferenceCameras";

  await axios
    .put(inferenceCameraApi, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("inferenceCameraNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
}

export async function removeInferenceCameras(data) {
  const inferenceCameraApi = "/v1/inferenceCameras";

  await axios
    .delete(inferenceCameraApi, { data: data })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("inferenceNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function getFences(inference_camera_uuid) {
  const guardianApi = "/v1/inferenceCameras/" + inference_camera_uuid + "/fences";
  let fences = []

  await axios
    .get(guardianApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("guardianNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.fences != undefined) {
        fences = response.data.fences;
      }
    })

  return fences
}

export async function addFence(inference_camera_uuid, data) {
  const guardianApi = "/v1/inferenceCameras/" + inference_camera_uuid + "/fences";

  await axios
    .post(guardianApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("guardianNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function updateFence(inference_camera_uuid, fence_uuid, data) {
  const guardianApi = "/v1/inferenceCameras/" + inference_camera_uuid + "/fences/" + fence_uuid;

  await axios
    .put(guardianApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("guardianNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function removeFence(inference_camera_uuid, fence_uuid) {
  const guardianApi = "/v1/inferenceCameras/" + inference_camera_uuid + "/fences/" + fence_uuid;

  await axios
    .delete(guardianApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("guardianNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}